import { render } from "./OrthoPatientHistory.vue?vue&type=template&id=41d2a220"
import script from "./OrthoPatientHistory.vue?vue&type=script&lang=js"
export * from "./OrthoPatientHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__